import { Fragment, h } from "preact";
import { sortBy } from "lodash";

import Avatar from "./Avatar.jsx";
import Tooltip from "./Tooltip.jsx";

import { uniqueID } from "../helpers.js";
import i18n from "../i18n.js";

export default function AvatarGroup({ users }) {
  const countTalents = users.length;
  const needsNumber = countTalents > 4;
  const avatars = needsNumber ? users.slice(0, 4) : users;

  const tooltipId = `tooltip-${uniqueID()}`;

  if (countTalents === 0) {
    return null;
  }
  return (
    <>
      <span class="avatar-group" data-tooltip-id={tooltipId}>
        {sortBy(avatars, (u) => u.name).map((user, index) => (
          <Avatar
            key={index}
            user={user}
            small
            plain
            noHover
            outlined
            colorVariant={["blue", "red", "lavender", "green"][index]}
          />
        ))}
        {needsNumber && (
          <span class="avatar-group__count">
            <span>+{Math.min(99, countTalents - 4)}</span>
          </span>
        )}
      </span>

      <Tooltip className="nioomi-tooltip" id={tooltipId} place="bottom">
        {i18n.t("component.avatar_group.talents", { count: countTalents })}
      </Tooltip>
    </>
  );
}
